

import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FOOTER } from '../../../shared/configs';

@Component({
    selector: 'app-footer',
    imports: [RouterModule, TranslateModule],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})

export class FooterComponent {

  readonly footer = FOOTER.footer;

  currentYear = new Date().getFullYear();

}
